module.exports = "/img/unitelfutebol-dark.svg?2ca1c6f71a2d19f766bfac24800583b5";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/identity/unitelfutebol-dark.svg
// module id = Fp4i
// module chunks = 72